import { Component } from '@angular/core';
import { ToastComponent } from '../toast.component';

@Component({
  selector: 'io-provetech-info-toast',
  templateUrl: './info-toast.component.html',
})
export class InfoToastComponent extends ToastComponent {}
